<template>
    <BreadCrumb PageTitle="Ajout des produits restreints" />
    <AddProduitRestreint />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddProduitRestreint from "@/components/ProduitRestreint/AddProduitRestreint.vue";

    export default defineComponent({
        name: "AddProduitRestreintPage",
        components: {
            BreadCrumb,
            AddProduitRestreint,
        },
    });
</script>